const classNames = {
    disabled: 'is-disabled',
    hover: 'is-hover',
    active: 'is-active',
    inActive: 'is-inactive',
    involved: 'is-involved',
    lazyLoading: 'is-loading',
    isVisible: 'is-visible',
    isCurrent: 'is-current',
    isDisplayed: 'is-displayed',
    lazyPreloader: 'js-lazy-loader',
    lazyImage: 'lazy__image',
    lazyLoaded: 'is-loaded',
    fixed: 'is-fixed',
    focused: 'is-focused',
    filled: 'is-filled',
    blurred: 'is-blurred',
    invalid: 'is-invalid',
    error: 'is-error',
    selected: 'is-selected',
    open: 'is-open',
    intlTelInput: 'js-intl-tel-input',
    intlTelInputMobile: 'iti-mobile',
    searchSelect: 'js-search-select',
    isThreeLetters: 'is-three-letters',
    isMacLikeDevice: 'is-mac-like-device'
};

const variables = {
    gsapDefaultDuration: .25,
    carouselDefaultDuration: 800,
    resizeDebounce: 100,
    inputDebounce: 200,
    throttleDebounce: 100,
    debugLogs: true,
    customEventNames: {
        resize: 'page-custom-event:resize-done',
        pageReady: 'page-custom-event:page-ready',
        selectDropdownSelected: 'page-custom-event:select-dropdown-selected',
        addClubCheckFieldVisibility: 'page-custom-event:personal-add-club-check-field-visibility',
        validatedFormSubmit: 'page-custom-event:validated-form-submitted',
        registrationUserTypeSelected: 'registration-user-type-selected',
        sortClicked: 'page-custom-event:sort-has-been-clicked',
        homeDatabaseViewChanged: 'page-custom-event:home-database-view-changed',
        personalTabChanged: 'page-custom-event:personal-tab-changed',
        personalCardsUpdated: 'page-custom-event:personal-cards-updated',
        addClubReset: 'page-custom-event:personal-add-club-reset-forms',
        addClubEdit: 'page-custom-event:personal-add-club-edit',
        addTournamentReset: 'page-custom-event:personal-add-tournament-reset-forms',
        addTournamentEdit: 'page-custom-event:personal-add-tournament-edit',
        recaptchaLoaded: 'page-custom-event:recaptcha-loaded',
        offersTabChanged: 'page-custom-event:offers-tab-changed',
        postCommentsTabChanged: 'page-custom-event:post-comments-tab-changed',
        blogTabChanged: 'tabs:blog-tab-changed',
        lazyImageLoaded: 'page-custom-event:vanilla-lazy-image-loaded',
        onLoginSuccess: 'page-custom-event:on-login-success',
    },
    classNames,
    formValidationMessages: {
        invalid         : 'Некорректное значение',
        short           : 'Значение недостаточной длины',
        long            : 'Превышена допустимая длина',
        checked         : 'Должно быть отмечено',
        empty           : 'Поле не заполнено',
        select          : 'Выберите из списка',
        number_min      : 'too low',
        number_max      : 'too high',
        url             : 'invalid URL',
        number          : 'not a number',
        email           : 'Некорректный e-mail',
        email_repeat    : 'emails do not match',
        date            : 'invalid date',
        time            : 'invalid time',
        password_repeat : 'Пароли не совпадают',
        no_match        : 'no match',
        complete        : 'Ввод не завершён',
        phone           : 'Некорректный номер телефона'
    },
    choicesOptions: {
        choices: [],
        allowHTML: true,
        loadingText: 'Загрузка...',
        noResultsText: 'Результаты не найдены',
        noChoicesText: 'Отсутствуют опции для выбора',
        itemSelectText: 'Нажмите, чтобы выбрать',
        shouldSort: false,
        classNames: {
            containerOuter: 'select',
            containerInner: 'select__inner',
            input: 'select__input',
            inputCloned: 'select__input--cloned',
            list: 'select__list',
            listItems: 'select__list--multiple',
            listSingle: 'select__list--single',
            listDropdown: 'select__list--dropdown',
            item: 'select__item',
            itemSelectable: 'select__item--selectable',
            itemDisabled: 'select__item--disabled',
            itemOption: 'select__item--choice',
            group: 'select__group',
            groupHeading : 'select__heading',
            button: 'select__button',
            activeState: classNames.active,
            focusState: classNames.focused,
            openState: 'is-open',
            disabledState: classNames.disabled,
            highlightedState: 'is-highlighted',
            selectedState: classNames.selected,
            flippedState: 'is-flipped',
            placeholder: 'select__placeholder'
        },
    },
    get windowWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    },
    get windowHeight() {
        return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    },
    scrollbarWidth:	window.innerWidth - document.documentElement.clientWidth,
    breakpoints: {
        m: 375,
        sm: 576,
        md: 768,
        lg: 1024,
        xl: 1580
    },
    dom: {
        header: document.getElementById('js-header'),
        wrapper: document.getElementById('js-page-wrapper'),
        footer: document.getElementById('js-footer'),
    },
    messages: {
        lazyError: 'Ошибка загрузки изображения'
    },
    hexColors: {
        primary: '#DC0000'
    },
    mapApiKey: document
        .querySelector('meta[name="ya-api-key"]')
        .getAttribute('content'),
    get mapUrl() {
      return `https://api-maps.yandex.ru/2.1/?apikey=${this.mapApiKey}&lang=ru_RU`
    },
    selectors: {
        select: '.js-custom-select',
        lazyElement: '.js-lazy-element',
        lazyWrapper: '.js-lazy-wrapper',
        buttonContent: '.js-button-content',
        cardClub: '.js-card-club',
        cardOfferClub: '.js-card-offer-club',
        cardOfferCompany: '.js-card-offer-company',
        cardPost: '.js-card-post',
        cardTournament: '.js-card-tournament',
        cardReview: '.js-card-review',
        cardAccess: '.js-card-access',
        fileUpload: '.js-file-upload',
        currencyIcon: '.js-currency-field-icon',
        recaptcha: '.js-form-recaptcha',
        recaptchaInput: '.g-recaptcha-response',
    },
    keys: {
        sort: {
            orderBy: 'order',
            orderKey: 'order_key'
        }
    },
    autoCompleteMaxResults: 10,
    autoCompleteClassNamePrefix: 'autocomplete_',
    clubCardIdPrefix: 'club-id-',
    tournamentCardIdPrefix: 'tournament-id-',
    metaNames: {
        userRole: 'user-role',
        token: 'token',
        //country: 'country', countryIso
        countryIso: 'countryIso',
        countrySlug: 'countryIso',
        //locale: 'locale', -
        isAdmin: 'is-admin',
        cityId: 'city-id'
    },
    userRoles: {
        owner: 'owner',
        player: 'player',
        guest: 'guest'
    },
    metricsAttr: 'data-metrics-payload',
    requiredUrlPartAttr: 'data-required-url-part',
    requiredUrlMessageAttr: 'data-required-url-message',
    searchTypes: {
        cities: 'cities',
        subway: 'subway',
        personalCities: 'personal-cities',
        addresses: 'addresses'
    },
    ids: {
        successMessageModal: 'js-modal-success-message'
    }
};

export default variables;
